import React from 'react';
import { Link } from 'react-router-dom';
import { FiGithub, FiTwitter, FiMail } from 'react-icons/fi';

function Footer() {
  return (
    <footer className="bg-white border-t-2 border-gray-200 py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-900">AVALW Extensions</h3>
            <p className="text-gray-600 text-sm">
              The official extension marketplace for Cronos Browser. Secure, compiled binary format for maximum protection.
            </p>
          </div>

          {/* Developers */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-900">Developers</h3>
            <div className="flex flex-col gap-2 text-gray-600 text-sm">
              <Link to="/docs" className="hover:text-gray-900 transition-colors">Documentation</Link>
              <Link to="/ai-assistant" className="hover:text-gray-900 transition-colors">Build with AI</Link>
              <Link to="/dashboard" className="hover:text-gray-900 transition-colors">Developer Dashboard</Link>
            </div>
          </div>

          {/* Marketplace */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-900">Marketplace</h3>
            <div className="flex flex-col gap-2 text-gray-600 text-sm">
              <Link to="/" className="hover:text-gray-900 transition-colors">Browse Extensions</Link>
              <Link to="/developers" className="hover:text-gray-900 transition-colors">Become a Developer</Link>
              <Link to="/dashboard" className="hover:text-gray-900 transition-colors">Submit Extension</Link>
            </div>
          </div>

          {/* Legal & Social */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-900">Legal & Connect</h3>
            <div className="flex flex-col gap-2 text-gray-600 text-sm mb-4">
              <Link to="/privacy" className="hover:text-gray-900 transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-gray-900 transition-colors">Terms of Service</Link>
              <a href="mailto:report@avalw.com" className="hover:text-gray-900 transition-colors">Report Extension</a>
            </div>
            <div className="flex gap-4">
              <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">
                <FiGithub className="text-2xl" />
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">
                <FiTwitter className="text-2xl" />
              </a>
              <a href="mailto:contact@avalw.com" className="text-gray-600 hover:text-gray-900 transition-colors">
                <FiMail className="text-2xl" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t-2 border-gray-200 pt-8 text-center text-gray-600 text-sm">
          <p>&copy; 2026 AVALW Marketplace. All rights reserved. Built for Cronos Browser.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
